Vue.component('MpModuleComments', {
    props: {
        title: String,
        counter: String,
        hasComments: String,
        addLabel: String,
        addAnchor: String,
        ssrSelector: String,
    },
    data: function() {
        return {
            commentList: [],

            isInitialized: false,
        };
    },
    computed: {
        nComments: function() {
            return this.commentList.length;
        }
    },
    methods: {

        addDomComment: function(comment) {
            this.commentList.push({
                author: comment.querySelector('.js-comment-author').innerHTML.trim(),
                date: comment.querySelector('.js-comment-date').innerHTML.trim(),
                content: comment.querySelector('.js-comment-content').innerHTML.trim(),
            });
        },

        init: function() {
            this.isInitialized = true;
        }
    },

    mounted: function() {
        var ssrComments = document.getElementById(this.ssrSelector);

        if (ssrComments) {
           ssrComments.querySelectorAll('.js-comment').forEach(this.addDomComment);
        }

        this.init();
    },

    updated: function() {},

    template: '\
    <div class="post-detail__comments u-mt-xxl" id="comments">\
        <div class="row align-items-center justify-content-between">\
            <div class="col-auto">\
                <h3 class="post-detail__section-title">{{nComments + \' \' + title}}</h3>\
            </div>\
            <div class="col-auto">\
                <a class="btn-link" href="#">\
                    <!-- TODO: @qmarcos @andres Traducciones pendientes -->\
                    <a :href="addAnchor" class="btn-link__label" v-if="nComments">+ {{addLabel}}</a>\
                </a>\
            </div>\
        </div>\
\
        <ul class="post-detail__comments-list" v-if="nComments">\
            <li class="post-detail__comment" v-for="comment in commentList">\
                <p class="post-detail__comment-header">\
                    <span class="post-detail__comment-name">{{comment.author}}</span>\
                    <span class="post-detail__comment-date">{{comment.date}}</span>\
                </p>\
                <p class="post-detail__comment-text" v-html="comment.content"></p>\
            </li>\
        </ul>\
    </div>',
});